import * as api from "./api";

export async function captureEventInfo(eventInfo) {
  const result = await api.mediaPost(`dialer-events`, eventInfo);
  return result;
}
